<template>
  <section class="carousel" :class="outerClasses">
    <div v-if="images.length > 0" class="pictures" :class="wrapperClasses" :style="style">
      <figure v-for="(img,index) in images" :class="slideClassName(index)" :key="'slide-' + index">
        <vue-picture :imgset="img" :sizes="sizes" :aspect="aspect"></vue-picture>
        <figcaption v-if="img.caption">{{img.caption}}</figcaption>
      </figure>
    </div>
    <div
      v-if="showNav && images.length > 1"
      class="arrow prev icon-triangle-prev click-overlay"
      @click="prev()"
    ></div>
    <div
      v-if="showNav && images.length > 1"
      class="arrow next icon-triangle-next click-overlay"
      @click="next()"
    ></div>
    <div
      v-if="showNav && images.length > 1"
      class="arrow prev touch-overlay icon-arrow-left"
      v-touch:swipe.right="prev"
      v-touch:tap="prev"
    ></div>
    <div
      v-if="showNav && images.length > 1"
      class="arrow next touch-overlay icon-arrow-right"
      v-touch:tap="next"
      v-touch:swipe.left="next"
    ></div>
    <nav v-if="showNav && images.length > 1" class="horizontal circles plain">
      <ol v-if="images.length > 0">
        <li
          v-for="(img,index) in images"
          :class="{'active': currIndex === index}"
          v-on:click="setActive(index)"
          :key="'bullet-' + index"
        >{{(index+1)}}</li>
      </ol>
    </nav>
  </section>
</template>
<script>
import VuePicture from "./VuePicture.vue";

export default {
  props: {
    images: {
      type: Array
    },
    sizes: {
      type: Array
    },
    speed: {
      type: Number,
      default: 3000
    },
    showNav: {
      type: Boolean,
      default: true
    },
    aspect: {
      type: String,
      default: "standard"
    }
  },
  data() {
    return {
      currIndex: 0,
      timer: null,
      wrapperClasses: ["forward"],
      picHeight: 0
    };
  },
  watch: {
    showNav(val) {
      if (val) {
        this.init();
      } else {
        this.setActive(0);
      }
    }
  },
  computed: {
    outerClasses() {
      let cls = ["num-images-" + this.images.length];
      cls.push(this.aspect.replace(/_+/g, "-"));
      return cls;
    },
    style() {
      let styleParts = [];
      if (this.picHeight > 20) {
        styleParts.push("padding:0");
        styleParts.push("height:" + this.picHeight + "px");
      }
      return styleParts.join(";");
    },
    naturalAspect() {
      switch (this.aspect) {
        case "standard":
          return true;
        default:
          return false;
      }
    }
  },
  created() {
    this.init();
    if (this.naturalAspect) {
      window.addEventListener("resize", this.calcPicHeight);
    }
  },
  mounted() {
    if (this.naturalAspect) {
      setTimeout(this.calcPicHeight, 333);
    }
  },
  destroy() {
    window.removeEventListener("resize", this.calcPicHeight);
  },
  methods: {
    init() {
      if (this.speed > 200 && this.images.length > 1) {
        this.timer = setInterval(() => {
          if (this.currIndex < this.images.length - 1) {
            this.currIndex++;
          } else {
            this.currIndex = 0;
          }
        }, this.speed);
      }
    },
    setActive(index) {
      const lastIndex = this.images.length - 1;
      let diff = Math.abs(index - this.currIndex);
      let forward = index > this.currIndex;
      if (this.currIndex === lastIndex && index === 0) {
        forward = true;
        diff = 1;
      } else if (this.currIndex === 0 && index === lastIndex) {
        forward = false;
        diff = 1;
      }
      if (this.currIndex <= lastIndex) {
        this.currIndex = index;
      } else {
        this.index = 0;
      }
      if (this.timer) {
        clearInterval(this.timer);
      }
      let dirClass = forward ? "forward" : "back";
      this.wrapperClasses = [dirClass, "transitioning"];
      if (diff > 1) {
        this.wrapperClasses.push("skipping");
      }
      setTimeout(() => {
        this.wrapperClasses = [dirClass];
      }, 1000);
    },
    next() {
      if (this.currIndex < this.images.length - 1) {
        this.setActive(this.currIndex + 1);
      } else {
        this.setActive(0);
      }
    },
    prev() {
      if (this.currIndex > 0) {
        this.setActive(this.currIndex - 1);
      } else {
        this.setActive(this.images.length - 1);
      }
    },
    slideClassName(index) {
      const lastIndex = this.images.length - 1;
      let cls = ["index-" + index];
      if (index === this.currIndex) {
        cls.push("active");
      }
      if (index === 0) {
        cls.push("first");
      } else if (index === lastIndex) {
        cls.push("last");
      }
      let isLastPrev = this.currIndex === 0 && index === lastIndex;
      let isFirstNext = this.currIndex === lastIndex && index === 0;
      if ((index === this.currIndex - 1 && !isFirstNext) || isLastPrev) {
        cls.push("prev-slide");
      } else if ((index === this.currIndex + 1 && !isLastPrev) || isFirstNext) {
        cls.push("next-slide");
      } else if (index > this.currIndex) {
        cls.push("next-inactive");
      } else if (index < this.currIndex) {
        cls.push("prev-inactive");
      }
      return cls;
    },
    calcPicHeight() {
      let maxHeight = 0;
      let imgs = this.$el.querySelectorAll("img");
      let numImgs = imgs.length;
      if (numImgs > 0) {
        for (let i = 0; i < numImgs; i++) {
          let lastImgComplete = imgs[numImgs - 1].complete !== false;
          if (lastImgComplete) {
            if (imgs[i].height) {
              let h = parseInt(imgs[i].height);

              if (h > maxHeight) {
                maxHeight = h;
              }
            }
          } else {
            setTimeout(this.calcPicHeight, 500);
          }
        }
      }
      this.picHeight = maxHeight;
    }
  },
  components: {
    VuePicture
  }
};
</script>